import { Component, OnInit, ViewChild } from '@angular/core';
import { LanguagesService } from 'src/app/services/language.service';
import { MoiaCaptchaComponent } from '../../components/moia-captcha/moia-captcha.component';
import { BaseService } from 'src/app/services/base.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ValidationService } from 'src/app/services/validation.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';
import { ConfigService } from 'src/app/services/config.service';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  form: FormGroup = null;
  isSubmitted = false;
  @ViewChild(MoiaCaptchaComponent) private captchaComponent: MoiaCaptchaComponent;
  

  constructor(public languagesService: LanguagesService,
              private baseService: BaseService,
              private titleService: Title,
              public router: Router,
              private configService: ConfigService,
              public translate:TranslateService) 
  {
	this.titleService.setTitle("תושבים חוזרים");
  }

  ngOnInit(): void {
    this.form = new FormGroup ({
      social_id : new FormControl('', [Validators.required, ValidationService.IdValidator]),
      email: new FormControl('', [Validators.required, ValidationService.emailValidator])
    });
  }

  public get f() {
    return this.form.controls;  
  }
  error = "";
  onSubmit() {
    this.isSubmitted = true;
    if (this.form.invalid)
      return;

    let captcha = "";
    let skipCaptcha = this.configService.getConfiguration().skipCaptcha;

    if (!skipCaptcha) {
      captcha = this.captchaComponent.GetResponse();
      if (!captcha) {
        return;
      }
    }

    this.baseService.checkLogin(this.f.social_id.value, this.f.email.value, captcha).subscribe((res: any) => {  
      if (res == false)    
      {
        //this.translate.get('notExsist').subscribe((text:string) => {this.error = text;});
        this.error ="הנתונים לא נמצאו במערכת";
      }
      else {
        if ((res as string).indexOf("Error") < 0) {
          this.baseService.LoggedUser = res[0];     
          this.router.navigate(['/welcome']);  
        }
      }
    });
    
  }
}
